import {RootState} from ".";

export const Selectors = {
  // App
  tenant: (state: RootState) => state.app.tenant,
  tenantId: (state: RootState) => state.app.tenant?.id,
  colorScheme: (state: RootState) => state.app.colorScheme,
  drawerOpen: (state: RootState) => state.app.drawerOpen,
  drawerIndex: (state: RootState) => state.app.drawerIndex,
  assets: (state: RootState) => state.app.assets,
  sensors: (state: RootState) => state.app.sensors,
  users: (state: RootState) => state.app.users,
  // Auth
  autoLogin: (state: RootState) => state.auth.autoLogin,
  user: (state: RootState) => state.auth.user,
  userId: (state: RootState) => state.auth.user?.id,
  userRole: (state: RootState) => state.auth.user?.role,
  accessToken: (state: RootState) => state.auth.accessToken,
  // Notifications
  liveMeasures: (state: RootState) => state.notifications.measures,
  events: (state: RootState) => state.notifications.events,
  lastEvent: (state: RootState) => state.notifications.lastEvent,
  // Locale
  locale: (state: RootState) => state.i18n.lang,
};
